// extracted by mini-css-extract-plugin
export default {"description":"infoTextBanner_description__10FEL"};